import { useContext } from "react";
import { ReplacementScheduleContext } from "../context";

export const useReplacement = () => useContext(ReplacementScheduleContext);
